export default __webpack_public_path__ + "static/media/HanaAssociation.04352e84.png";